// extracted by mini-css-extract-plugin
export default {"chat":"CreateChatModal_chat__d0Of8","chat__header":"CreateChatModal_chat__header__T22dK"};